import type { Middleware } from "redux";

import * as actionTypes from "@/redux/actions/actionTypes";
import type { AppDispatch, RootState } from "@/redux/store";
import { clearFlagInterval, loadTargetedFlags } from "@/redux/actions/featureFlag";
import { getUsernameFromToken } from "@/utils/authToken";

export const featureFlagMiddleware: Middleware<unknown, RootState, AppDispatch> =
  (store) => (next) => (action) => {
    const dispatch = store.dispatch;

    if (action.type === actionTypes.LOG_OUT) {
      dispatch(clearFlagInterval());
    }

    const result = next(action);

    if (action.type === actionTypes.AUTH_SUCCESS || action.type === actionTypes.LOAD_TOKEN) {
      // Reducer has already written the new token to localStorage by this point
      const username = getUsernameFromToken();

      if (username) dispatch(loadTargetedFlags());
    }

    return result;
  };
